<div class="flex flex-col items-center gap-2">
  <p-button
    severity="secondary"
    icon="pi pi-download"
    label="{{ 'impactReport.downloadPDF' | transloco }}"
    (onClick)="showDialog()"
    [loading]="graphService.loading"
    data-testid="open.export-pdf-dialog-button"
  />
</div>
<p-dialog [(visible)]="visible" [modal]="true" [style]="{ width: '50vw' }">
  <ng-template pTemplate="header">
    <div class="inline-flex items-center justify-center gap-4">
      <i class="pi pi-file-export" style="font-size: 2rem"></i>
      <div class="flex flex-col gap-2">
        <h1 class="text-xl font-semibold text-black">
          {{ "impactReport.exportReport" | transloco }}
        </h1>
        <p class="text-sm">
          {{ "impactReport.selectSelection" | transloco }}
        </p>
      </div>
    </div>
  </ng-template>

  <div class="flex flex-col">
    <div
      class="flex flex-row items-center justify-between rounded-md border-2 border-slate-100 p-2 shadow-sm"
    >
      <div class="flex flex-row items-center gap-4">
        <div
          class="flex h-10 w-10 items-center justify-center rounded-full bg-slate-200"
        >
          <i class="pi pi-check" style="color: black"></i>
        </div>
        <div>
          <h2 class="text-lg font-medium text-black">
            {{ "impactReport.selectAll" | transloco }}
          </h2>
          <p>{{ "impactReport.includeAll" | transloco }}</p>
        </div>
      </div>
      <div>
        <p-toggleSwitch
          [(ngModel)]="graphService.checked"
          (onChange)="graphService.toggleAllCategories()"
        ></p-toggleSwitch>
      </div>
    </div>

    <div class="mt-4 grid grid-cols-2 gap-4">
      @for (category of graphService.graphCategories; track category) {
        <div
          class="flex flex-col gap-4 rounded-md border-2 border-slate-100 p-2 shadow-sm"
        >
          <div class="flex w-full flex-row items-center justify-between">
            <div class="flex flex-row items-center gap-4">
              <i-lucide name="{{ category.icon }}"></i-lucide>
              <h2 class="text-lg font-medium text-black">
                {{ "impactReport." + category.name | transloco }}
              </h2>
            </div>
            <p-toggleSwitch
              [(ngModel)]="graphService.graphOptions[category.key]"
              (onChange)="graphService.updateMainToggle()"
            >
            </p-toggleSwitch>
          </div>
          <p class="">
            {{ "impactReport." + category.description | transloco }}
          </p>
        </div>
      }
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="grid w-full grid-cols-2">
      <div class="flex flex-row items-center gap-4">
        <i class="pi pi-info-circle" style="font-size: 0.8rem"></i>
        <p>{{ "impactReport.reportPDF" | transloco }}</p>
      </div>
      <div class="flex justify-end gap-4">
        <p-button
          label="{{ 'impactReport.cancel' | transloco }}"
          [text]="true"
          severity="secondary"
          (click)="closeDialog()"
        ></p-button>
        <p-button
          icon="pi pi-file-pdf"
          label="{{ 'impactReport.downloadPDF' | transloco }}"
          [outlined]="true"
          (click)="graphService.exportStyledPDF(this.impactReportData, this)"
          data-testid="download.exported-pdf-button"
        ></p-button>
      </div>
    </div>
  </ng-template>
</p-dialog>
